// extracted by mini-css-extract-plugin
export default {"item":"RoomItem_item__MBSoY","title":"RoomItem_title__cBn1q","right__wrapper":"RoomItem_right__wrapper__Kg3KE","user":"RoomItem_user__S3yE0","lock":"RoomItem_lock__uc3x8"};